import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default {
  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.initializeComponents);
    } else {
      this.initializeComponents();
    }
  },

  initializeComponents() {
    // Mobile menu functionality
    this.initMobileMenu();

    // Step functionality
    this.initSteps();

    // Initialize all swipers
    this.initSwipers();

    this.initCounters();
    setTimeout(() => {
      this.initPageScripts();      
    }, 700);
  },
  initCounters() {
    const stats = document.getElementById('stats');
    if (!stats) return;

    let hasRun = false;

    function inView() {
      const winTop = window.pageYOffset || document.documentElement.scrollTop;
      const winBottom = winTop + window.innerHeight;
      const rect = stats.getBoundingClientRect();
      const elTop = rect.top + winTop;
      const elBottom = elTop + stats.offsetHeight;
      const visibleTop = Math.max(winTop, elTop);
      const visibleBottom = Math.min(winBottom, elBottom);
      const visible = Math.max(0, visibleBottom - visibleTop);
      return visible >= 0.35 * stats.offsetHeight;
    }

    function animateNumber(element, target, suffix, duration = 1200) {
      const start = performance.now();
      const startValue = 0;

      function animate(currentTime) {
        const elapsed = currentTime - start;
        const progress = Math.min(elapsed / duration, 1);

        // Easing function (swing/ease-in-out)
        const eased = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        const current = startValue + (target - startValue) * eased;
        element.textContent = Math.round(current) + suffix;

        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      }

      requestAnimationFrame(animate);
    }

    function runCounters() {
      const statValues = stats.querySelectorAll('.stat__value');

      statValues.forEach(element => {
        const target = parseFloat(element.dataset.count) || 0;
        const currentText = (element.textContent || '').trim();
        const suffixMatch = currentText.match(/[^\d.\s]+$/);
        const suffix = suffixMatch ? suffixMatch[0] : '';

        animateNumber(element, target, suffix);
      });
    }

    function check() {
      if (!hasRun && inView()) {
        hasRun = true;
        runCounters();
        window.removeEventListener('scroll', check);
        window.removeEventListener('resize', check);
      }
    }

    window.addEventListener('scroll', check);
    window.addEventListener('resize', check);
    check(); // Check immediately in case already in view
  },
  initMobileMenu() {
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const mobileNavOverlay = document.getElementById('mobileNavOverlay');
    const mobileNavClose = document.getElementById('mobileNavClose');
    const mobileNavBackdrop = document.querySelector('.mobile-nav-backdrop');
    const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
    const mobileAuthButtons = document.querySelectorAll('.mobile-auth-buttons .btn');
    console.log(mobileNavOverlay);
    function openMobileMenu() {
      if (mobileNavOverlay) {
        mobileNavOverlay.classList.add('active');
        console.log(mobileNavOverlay);
        document.body.style.overflow = 'hidden';
      }
    }

    function closeMobileMenu() {
      if (mobileNavOverlay) {
        mobileNavOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    }

    if (mobileMenuToggle) {
      mobileMenuToggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openMobileMenu();
      });
      mobileMenuToggle.setAttribute('aria-label', 'Open mobile menu');
    }

    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeMobileMenu();
      });
      mobileNavClose.setAttribute('aria-label', 'Close mobile menu');
    }

    if (mobileNavBackdrop) {
      mobileNavBackdrop.addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileMenu();
      });
    }

    mobileNavLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        closeMobileMenu();
      });
    });

    mobileAuthButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closeMobileMenu();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNavOverlay && mobileNavOverlay.classList.contains('active')) {
        closeMobileMenu();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024 && mobileNavOverlay && mobileNavOverlay.classList.contains('active')) {
        closeMobileMenu();
      }
    });

    // Smooth scrolling for anchor links
    const allLinks = document.querySelectorAll('a[href^="#"]');
    allLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href !== '#') {
          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      });
    });
  },

  initSteps() {
    const steps = document.querySelectorAll(".step");
    steps.forEach((s, i) => s.classList.toggle("step--active", i === 0));

    steps.forEach(step => {
      step.addEventListener("click", () => {
        steps.forEach(s => s.classList.remove("step--active"));
        step.classList.add("step--active");
      });
    });
  },

  initSwipers() {
    // BLOGS Swiper
    const blogsSection = document.querySelector('.blogs');
    const blogsContainer = document.querySelector('.blogs-swiper');

    if (blogsContainer) {
      try {
        new Swiper(blogsContainer, {
          slidesPerView: 3,
          spaceBetween: 24,
          speed: 550,
          grabCursor: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: blogsSection ? blogsSection.querySelector('.blogs-next') : '.blogs-next',
            prevEl: blogsSection ? blogsSection.querySelector('.blogs-prev') : '.blogs-prev'
          },
          breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 16 },
            475: { slidesPerView: 2, spaceBetween: 20 },
            980: { slidesPerView: 3, spaceBetween: 24 }
          }
        });
        console.log('Blogs swiper initialized successfully');
      } catch (error) {
        console.error('Error initializing blogs swiper:', error);
      }
    } else {
      console.warn('Blogs swiper container not found');
    }

    // Testimonials Swiper
const tSwiperContainer = document.querySelector(".swiper-container.testimonial-slider");

if (tSwiperContainer) {
  const wrapper = tSwiperContainer.querySelector(".swiper-wrapper");
  const slides = wrapper.querySelectorAll(".swiper-slide");

  // ✅ Duplicate each slide twice
  slides.forEach((slide) => {
    const clone1 = slide.cloneNode(true);
    const clone2 = slide.cloneNode(true);
    wrapper.appendChild(clone1);
    wrapper.appendChild(clone2);
  });

  try {
    new Swiper(tSwiperContainer, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      speed: 600,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "fraction",
      },
      navigation: {
        nextEl: ".t-next",
        prevEl: ".t-prev",
      },
      breakpoints: {
        320: { slidesPerView: 2, spaceBetween: 16 },
        767: { slidesPerView: 3, spaceBetween: 16 },
        980: { slidesPerView: 3, spaceBetween: 20 },
        1024: { slidesPerView: 4, spaceBetween: 20 },
        1280: { slidesPerView: 5, spaceBetween: 20 },
      },
    });
    console.log("Testimonials swiper initialized successfully with duplicates");
  } catch (error) {
    console.error("Error initializing testimonials swiper:", error);
  }
} else {
  console.warn("Testimonials swiper container not found");
}



    // Products Swiper
    const pSwiperContainer = document.querySelector(".swiper-container.product-slider");
    if (pSwiperContainer) {
      try {
        new Swiper(pSwiperContainer, {
          slidesPerView: 2,
          spaceBetween: 20,
          cssMode: false,
          loop: true,
          speed: 600,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            320: { spaceBetween: 10 },
            767: { spaceBetween: 20 },
          },
          allowTouchMove: false,
          grabCursor: false,
          mousewheel: false,
        });

        console.log('Products swiper initialized successfully');
      } catch (error) {
        console.error('Error initializing products swiper:', error);
      }
    } else {
      console.warn('Products swiper container not found');
    }

    // Brand Slider
    const brandSliderContainer = document.querySelector(".brand-slider");
    console.log(brandSliderContainer);
    if (brandSliderContainer) {
      try {
       const swiper = new Swiper(brandSliderContainer, {
       speed: 4000,
       loop: true,
       freeMode: true,
       freeModeMomentum: false,
       grabCursor: false,
       autoplay: {
       delay: 0,
       disableOnInteraction: false,
      },
      allowTouchMove: false, // no user drag
      slidesPerView: 'auto',
      spaceBetween: 0,
      keyboard: false,
      pagination: false,
      navigation: false,
        breakpoints: {
          320: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1000: { slidesPerView: 4 },
          1200: { slidesPerView: 5 }
        },
      });
        ["mousedown", "mouseup", "click", "touchstart", "touchend"].forEach(evt => {
          brandSliderContainer.addEventListener(evt, () => swiper.autoplay.start());
        });
        console.log('Brand slider initialized successfully');
      } catch (error) {
        console.error('Error initializing brand slider:', error);
      }
    }
  },

  initPageScripts() {
   jQuery(function ($) {
      const $wrap = $('.cfu-accordion');

      $wrap.on('click', '.cfu-acc__summary', function () {
        const $btn = $(this);
        const $panel = $btn.next('.cfu-acc__panel');
        const isOpen = $btn.attr('aria-expanded') === 'true';

        // close others
        $wrap.find('.cfu-acc__summary[aria-expanded="true"]')
          .not($btn)
          .each(function () {
            $(this).attr('aria-expanded', 'false')
              .removeClass('is-open')
              .next('.cfu-acc__panel').stop(true, true).slideUp(250);
          });

        // toggle this
        if (isOpen) {
          $btn.attr('aria-expanded', 'false').removeClass('is-open');
          $panel.stop(true, true).slideUp(250);
        } else {
          $btn.attr('aria-expanded', 'true').addClass('is-open');
          $panel.stop(true, true).slideDown(250);
        }
      });
      $('.acc-item[aria-expanded="true"]')
        .next('.acc-panel')
        .show();

      $('.acc-item').on('click', function () {
        const $btn = $(this);
        const isOpen = $btn.attr('aria-expanded') === 'true';
        $('.acc-item').attr('aria-expanded', 'false')
          .next('.acc-panel').stop(true, true).slideUp(250);
        if (!isOpen) {
          $btn.attr('aria-expanded', 'true')
            .next('.acc-panel').stop(true, true).slideDown(250);
        }
      });
      function refresh($field) {
        var $el = $field.find('input, textarea, select').first();
        var val = $el.is('select') ? $el.val() : ($el.val() || '').trim();
        $field.toggleClass('is-filled', !!val);
      }
      $('.cfu-field.cfu-float,.woocommerce-form-login,.woocommerce-checkout,.woocommerce-address-fields__field-wrapper .form-row ').each(function () {
        var $field = $(this);
        console.log($field);
        var $el = $field.find('input, textarea, select').first();
        refresh($field);

        $el.on('focus', function () { $field.addClass('is-focused'); });
        $el.on('blur', function () { $field.removeClass('is-focused'); refresh($field); });
        $el.on('input change', function () { refresh($field); });
      });
      $('.cfu-eye').on('click', function () {
        var $btn = $(this);
        var $inp = $btn.closest('.cfu-field').find('input');
        var show = $inp.attr('type') === 'password';
        $inp.attr('type', show ? 'text' : 'password');
        $btn.toggleClass('is-on', show).attr('aria-pressed', show);
      });
      function isSelectFilled($sel) {
        var val = $sel.val();
        var $opt = $sel.find('option:selected');
        return val !== null && val !== '' && !$opt.prop('disabled') && !$opt.is('[hidden]');
      }

      $('.cfu-field.cfu-float select').each(function () {
        var $sel = $(this);
        var $field = $sel.closest('.cfu-field');
        $field.toggleClass('is-filled', isSelectFilled($sel));

        $sel.on('focus', function () { $field.addClass('is-focused'); });

        $sel.on('blur', function () {
          $field.removeClass('is-focused')
            .toggleClass('is-filled', isSelectFilled($sel));
        });
        $sel.on('change', function () {
          $field.toggleClass('is-filled', isSelectFilled($sel))
            .removeClass('is-focused');
        });
      });
      $('#latestBtn').on('click', function () {
        const dropdown = $('#latestDropdown');
        dropdown.toggleClass('show');
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', String(!expanded));
      });
      setInterval(function() {
          if ($('.cf7-popup').hasClass('active')) {
            $('body').addClass('popup-active');
          } else {
            $('body').removeClass('popup-active');
          }
        }, 200);
        $('#order-contact-popup button.cf7-popup-close').on('click', function() {
          $('.cf7-popup').removeClass('active');
          $('body').removeClass('popup-active');
        });

      $(document).on('click', function (event) {
        if (!$(event.target).closest('#latestBtn').length && !$(event.target).closest('#latestDropdown').length) {
          $('#latestDropdown').removeClass('show');
          $('#latestBtn').attr('aria-expanded', 'false');
        }
      });
    })

  },
  finalize() {

  },
};
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cfu-prodcard__body").forEach(body => {
    const desc = body.querySelector(".cfu-prodcard__desc");
    if (desc && desc.textContent.trim()) {
      const fullText = desc.textContent.trim();
      if (!body.querySelector(".cfu-tooltip")) {
        const tooltip = document.createElement("div");
        tooltip.className = "cfu-tooltip";
        tooltip.textContent = fullText;
        body.appendChild(tooltip);
      }
    }
  });
});